module.exports = __webpack_public_path__ + "media/images/wealthbar/dashboard/savings-a25be8d23d209201a6abb533f688b7a7.svg";